import React from 'react';

interface CTPProgressTrackerProps {
  answers: boolean[];
  total: number;
}

export const CTPProgressTracker: React.FC<CTPProgressTrackerProps> = ({ answers, total }) => {
  return (
    <div className="flex gap-1.5">
      {Array.from({ length: total }, (_, i) => {
        const answered = i < answers.length;
        let bg: string;
        if (!answered) {
          bg = 'var(--ctp-dot-pending)';
        } else if (answers[i]) {
          bg = 'var(--ctp-correct)';
        } else {
          bg = 'var(--ctp-wrong)';
        }

        return (
          <div
            key={i}
            className="flex-1 h-1.5 rounded-full transition-colors duration-300"
            style={{ backgroundColor: bg }}
          />
        );
      })}
    </div>
  );
};
